export const CnFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ borderRadius: '10px' }}
    >
      <rect
        width="20"
        height="20"
        fill="#DE2910"
      />
      <g fill="#FFDE00">
        {/* Big star */}
        <polygon points="3,3 3.6,4.8 5.6,4.8 4,6 4.6,7.8 3,6.6 1.4,7.8 2,6 0.4,4.8 2.4,4.8" />
        {/* Small stars */}
        <polygon
          transform="translate(6,1.5) scale(0.4)"
          points="3,3 3.6,4.8 5.6,4.8 4,6 4.6,7.8 3,6.6 1.4,7.8 2,6 0.4,4.8 2.4,4.8"
        />
        <polygon
          transform="translate(7.5,3.2) scale(0.4)"
          points="3,3 3.6,4.8 5.6,4.8 4,6 4.6,7.8 3,6.6 1.4,7.8 2,6 0.4,4.8 2.4,4.8"
        />
        <polygon
          transform="translate(7.5,5.5) scale(0.4)"
          points="3,3 3.6,4.8 5.6,4.8 4,6 4.6,7.8 3,6.6 1.4,7.8 2,6 0.4,4.8 2.4,4.8"
        />
        <polygon
          transform="translate(6,7) scale(0.4)"
          points="3,3 3.6,4.8 5.6,4.8 4,6 4.6,7.8 3,6.6 1.4,7.8 2,6 0.4,4.8 2.4,4.8"
        />
      </g>
    </svg>
  );
};
